"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2567],{

/***/ 52567:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Belt_Result = __webpack_require__(86369);
var Caml_option = __webpack_require__(57175);
var Js_null_undefined = __webpack_require__(5733);
var Util$SmartcutsMacros = __webpack_require__(25092);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function getExn(msg, result) {
    if (result.TAG === /* Ok */ 0) {
        return result._0;
    }
    console.error(result._0);
    return Util$SmartcutsMacros.logAndRaiseJsError("decco decoding error: " + msg);
}
function timeoutId_encode(timeoutId) {
    return timeoutId;
}
function timeoutId_decode(json) {
    var floatNum = Js_json.decodeNumber(json);
    if (floatNum !== undefined) {
        return {
            TAG: /* Ok */ 0,
            _0: floatNum | 0
        };
    } else {
        return Decco.error(undefined, "Couldn't decode json into timeoutId; unrecognized json " + JSON.stringify(json), json);
    }
}
function intervalId_encode(intervalId) {
    return intervalId;
}
function intervalId_decode(json) {
    var floatNum = Js_json.decodeNumber(json);
    if (floatNum !== undefined) {
        return {
            TAG: /* Ok */ 0,
            _0: floatNum | 0
        };
    } else {
        return Decco.error(undefined, "Couldn't decode json into intervalId; unrecognized json " + JSON.stringify(json), json);
    }
}
function MakeDerivingAbstractDeccoFns(DerivingAbstractDecco) {
    var _$t_encode = function _$t_encode(prim) {
        return prim;
    };
    var _$t_decode = function _$t_decode(encoded) {
        return {
            TAG: /* Ok */ 0,
            _0: encoded
        };
    };
    return {
        t_encode: _$t_encode,
        t_decode: _$t_decode
    };
}
function MakePolymorphicWithDeccoFns(PolymorphicDecco) {
    var tToJs = PolymorphicDecco.tToJs;
    var tFromJs = PolymorphicDecco.tFromJs;
    var _$t_encode = Curry.__1(tToJs);
    var _$t_decode = function _$t_decode(encoded) {
        var str = Js_json.decodeString(encoded);
        if (str === undefined) {
            return Decco.error(undefined, "Couldn't decode json into " + PolymorphicDecco.typeName, encoded);
        }
        var poly = Curry._1(tFromJs, str);
        if (poly !== undefined) {
            return {
                TAG: /* Ok */ 0,
                _0: Caml_option.valFromOption(poly)
            };
        } else {
            return Decco.error(undefined, "Couldn't decode json into " + (PolymorphicDecco.typeName + ("; unrecognized token " + StringUtils$SmartcutsMacros.quote(str))), encoded);
        }
    };
    return {
        tToJs: tToJs,
        tFromJs: tFromJs,
        t_encode: _$t_encode,
        t_decode: _$t_decode
    };
}
function unitToUnit_encode(param) {
    return "() => ()";
}
function unitToUnit_decode(encoded) {
    var str = Js_json.decodeString(encoded);
    if (str !== undefined) {
        if (str === "() => ()") {
            return {
                TAG: /* Ok */ 0,
                _0: function(param) {}
            };
        } else {
            return Decco.error(undefined, "Expected '() => ()' json string, but got " + StringUtils$SmartcutsMacros.quote(str), encoded);
        }
    } else {
        return Decco.error(undefined, "Couldn't decode json into unitToUnit", encoded);
    }
}
function MakeJSONDataWithDeccoFns(JSONData) {
    var _$t_decode = function _$t_decode(encoded) {
        return {
            TAG: /* Ok */ 0,
            _0: encoded
        };
    };
    return {
        t_decode: _$t_decode
    };
}
function decodable_encode(encoder_data, v) {
    if (v.TAG === /* Decoded */ 0) {
        return [
            "Decoded",
            Curry._1(encoder_data, v._0)
        ];
    } else {
        return [
            "UnableToDecode",
            v._0
        ];
    }
}
function decodable_decode(decoder_data, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Decoded":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(decoder_data, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Decoded */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "UnableToDecode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = {
                    TAG: /* Ok */ 0,
                    _0: Belt_Array.getExn(jsonArr$1, 1)
                };
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UnableToDecode */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function getDecodedExn(v) {
    if (v.TAG === /* Decoded */ 0) {
        return v._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Couldn't decode json into data; unrecognized json " + JSON.stringify(v._0));
    }
}
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "path",
            Decco.stringToJson(v.path)
        ],
        [
            "message",
            Decco.stringToJson(v.message)
        ],
        [
            "value",
            v.value
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var path = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "path"), null));
    if (path.TAG === /* Ok */ 0) {
        var message = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "message"), null));
        if (message.TAG === /* Ok */ 0) {
            var value = {
                TAG: /* Ok */ 0,
                _0: Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null)
            };
            if (value.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        path: path._0,
                        message: message._0,
                        value: value._0
                    }
                };
            }
            var e = value._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".value" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = message._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".message" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = path._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".path" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fromDeccoDecodeError(param) {
    return {
        path: param.path,
        message: param.message,
        value: param.value
    };
}
var SerializableDeccoDecodeError = {
    t_encode: t_encode,
    t_decode: t_decode,
    fromDeccoDecodeError: fromDeccoDecodeError
};
function t_encode$1(encode, nullable) {
    if (nullable == null) {
        return null;
    } else {
        return Curry._1(encode, nullable);
    }
}
function t_decode$1(decode, json) {
    var maybeDecoded = Belt_Option.flatMap(Js_json.decodeNull(json), function(prim) {
        if (prim === null) {
            return;
        } else {
            return Caml_option.some(prim);
        }
    });
    if (maybeDecoded !== undefined) {
        return Belt_Result.map(Curry._1(decode, Caml_option.valFromOption(maybeDecoded)), function(v) {
            return Js_null_undefined.fromOption(Caml_option.some(v));
        });
    } else {
        return {
            TAG: /* Ok */ 0,
            _0: null
        };
    }
}
var Nullable = {
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
exports.getExn = getExn;
exports.timeoutId_encode = timeoutId_encode;
exports.timeoutId_decode = timeoutId_decode;
exports.intervalId_encode = intervalId_encode;
exports.intervalId_decode = intervalId_decode;
exports.MakeDerivingAbstractDeccoFns = MakeDerivingAbstractDeccoFns;
exports.MakePolymorphicWithDeccoFns = MakePolymorphicWithDeccoFns;
exports.unitToUnit_encode = unitToUnit_encode;
exports.unitToUnit_decode = unitToUnit_decode;
exports.MakeJSONDataWithDeccoFns = MakeJSONDataWithDeccoFns;
exports.decodable_encode = decodable_encode;
exports.decodable_decode = decodable_decode;
exports.getDecodedExn = getDecodedExn;
exports.SerializableDeccoDecodeError = SerializableDeccoDecodeError;
exports.Nullable = Nullable; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 93437:
/***/ (function(__unused_webpack_module, exports) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Locale = {
    enUS: "en-US"
};
var _map = {
    "long": "long",
    "short": "short"
};
function compactDisplayToJs(param) {
    return param;
}
function compactDisplayFromJs(param) {
    return _map[param];
}
var _map$1 = {
    "USD": "USD"
};
function currencyToJs(param) {
    return param;
}
function currencyFromJs(param) {
    return _map$1[param];
}
var _map$2 = {
    "symbol": "symbol",
    "narrowSymbol": "narrowSymbol",
    "code": "code",
    "name": "name"
};
function currencyDisplayToJs(param) {
    return param;
}
function currencyDisplayFromJs(param) {
    return _map$2[param];
}
var _map$3 = {
    "accounting": "accounting",
    "standard": "standard"
};
function currencySignToJs(param) {
    return param;
}
function currencySignFromJs(param) {
    return _map$3[param];
}
var _map$4 = {
    "standard": "standard",
    "scientific": "scientific",
    "engineering": "engineering",
    "compact": "compact"
};
function notationToJs(param) {
    return param;
}
function notationFromJs(param) {
    return _map$4[param];
}
var _map$5 = {
    "auto": "auto",
    "never": "never",
    "always": "always",
    "exceptZero": "exceptZero"
};
function signDisplayToJs(param) {
    return param;
}
function signDisplayFromJs(param) {
    return _map$5[param];
}
var _map$6 = {
    "decimal": "decimal",
    "currency": "currency",
    "percent": "percent",
    "unit": "unit"
};
function styleToJs(param) {
    return param;
}
function styleFromJs(param) {
    return _map$6[param];
}
var InitOptions = {
    compactDisplayToJs: compactDisplayToJs,
    compactDisplayFromJs: compactDisplayFromJs,
    currencyToJs: currencyToJs,
    currencyFromJs: currencyFromJs,
    currencyDisplayToJs: currencyDisplayToJs,
    currencyDisplayFromJs: currencyDisplayFromJs,
    currencySignToJs: currencySignToJs,
    currencySignFromJs: currencySignFromJs,
    notationToJs: notationToJs,
    notationFromJs: notationFromJs,
    signDisplayToJs: signDisplayToJs,
    signDisplayFromJs: signDisplayFromJs,
    styleToJs: styleToJs,
    styleFromJs: styleFromJs
};
var NumberFormat = {
    InitOptions: InitOptions
};
exports.Locale = Locale;
exports.NumberFormat = NumberFormat; /* No side effect */ 


/***/ }),

/***/ 13257:
/***/ (function(__unused_webpack_module, exports) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var newLineRe = /\n/;
var newLineReGlobal = /\n/g;
var startingConsecutiveNewLinesReGlobal = /^\n+/g;
var startAndEndWithConsecutiveNewLinesReGlobal = /^\n+$/m;
var nonNewLineRe = /[^\n]/;
function makeNewLinesRegex(flags, numNewLinesPerEnter) {
    return new RegExp("\\n{" + (String(numNewLinesPerEnter) + "}"), flags);
}
var tokenRe = /[^\s]+/;
var googleSheetsRe = new RegExp("^https:\\/\\/docs.google.com\\/spreadsheets\\/d\\/([\\w-]+)(\\/edit)?");
var urlRe = new RegExp("^https?:\\/\\/.+");
function isUrl(str) {
    return urlRe.test(str);
}
function endsWithNumber(str) {
    return /\d+$/.test(str);
}
exports.newLineRe = newLineRe;
exports.newLineReGlobal = newLineReGlobal;
exports.startingConsecutiveNewLinesReGlobal = startingConsecutiveNewLinesReGlobal;
exports.startAndEndWithConsecutiveNewLinesReGlobal = startAndEndWithConsecutiveNewLinesReGlobal;
exports.nonNewLineRe = nonNewLineRe;
exports.makeNewLinesRegex = makeNewLinesRegex;
exports.tokenRe = tokenRe;
exports.googleSheetsRe = googleSheetsRe;
exports.urlRe = urlRe;
exports.isUrl = isUrl;
exports.endsWithNumber = endsWithNumber; /* googleSheetsRe Not a pure module */ 


/***/ }),

/***/ 61217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Ord = __webpack_require__(61618);
var Caml = __webpack_require__(16253);
var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var $$String = __webpack_require__(65760);
var Js_math = __webpack_require__(84763);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Caml_option = __webpack_require__(57175);
var Intl$SmartcutsMacros = __webpack_require__(93437);
var Util$SmartcutsMacros = __webpack_require__(25092);
var RegExUtils$SmartcutsMacros = __webpack_require__(13257);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
__webpack_require__(8269);
function withOrd(n) {
    return String(n) + Ord(n);
}
function isNewLine(s) {
    if (s.length === 1) {
        return s.charCodeAt(0) === 10.0;
    } else {
        return false;
    }
}
function quote(str) {
    return '"' + (str + '"');
}
function indent(indentWithOpt, times) {
    var indentWith1 = indentWithOpt !== undefined ? indentWithOpt : "  ";
    return $$Array.fold_left(function(indentation, indentWith) {
        return indentation + indentWith;
    }, "", Caml_array.make(times, indentWith1));
}
function repeat(times, str) {
    return Belt_Array.reduce(Caml_array.make(times, str), "", function(accumStr, s) {
        return accumStr + s;
    });
}
function reverse(s) {
    return $$String.concat("", Belt_List.fromArray(Array.from(s).reverse()));
}
var join = $$String.concat;
function split(on, s) {
    return Belt_List.fromArray(s.split(on));
}
function slice(from, to_, str) {
    return str.slice(from, to_);
}
function endsWith(s1, s2) {
    var s1Length = s1.length;
    return s2 === slice(s1Length - s2.length | 0, s1Length, s1);
}
function beginsWith(s1, s2) {
    return s1.indexOf(s2) === 0;
}
function capitalizeFirstLetter(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}
function removeTrailingSuffix(str, trailingSuffix) {
    if (endsWith(str, trailingSuffix)) {
        return slice(0, str.length - trailingSuffix.length | 0, str);
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("removeTrailingSuffix tried removing " + (quote(trailingSuffix) + (" from the end of " + (quote(str) + " but it is not the trailing suffix"))));
    }
}
function removeLeadingPrefix(str, prefix) {
    if (beginsWith(str, prefix)) {
        return slice(prefix.length, str.length, str);
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("removeLeadingPrefix tried removing " + (quote(prefix) + (" from the beginning of " + (quote(str) + (" but " + (quote(str) + (" doesn't begin with " + quote(prefix))))))));
    }
}
function commonPrefix(str1, str2) {
    var arr1 = Array.from(str1);
    var arr2 = Array.from(str2);
    var index1 = Belt_Array.reduce(Belt_Array.zip(arr1, arr2), [
        0,
        0
    ], function(param, nextPair) {
        var index = param[1];
        var commonIndex = param[0];
        if (commonIndex < index || nextPair[0] !== nextPair[1]) {
            return [
                commonIndex,
                index + 1 | 0
            ];
        } else {
            return [
                commonIndex + 1 | 0,
                index + 1 | 0
            ];
        }
    })[0];
    return OptionUtils$SmartcutsMacros.optionalString(str1.slice(0, index1));
}
function joinArrayWithCommaAnd(strings) {
    var match = List.rev($$Array.to_list(strings));
    if (!match) {
        return "";
    }
    var otherWordsReversed = match.tl;
    var lastWord = match.hd;
    if (otherWordsReversed) {
        if (otherWordsReversed.tl) {
            return $$String.concat(", ", List.rev(otherWordsReversed)) + (", and" + lastWord);
        } else {
            return otherWordsReversed.hd + (" and " + lastWord);
        }
    } else {
        return lastWord;
    }
}
function pluralize(count, singularWord) {
    return singularWord + (count !== 0 && count === 1 ? "" : "s");
}
var $$Uint8Array = {};
var $$TextEncoder = {
    $$Uint8Array: $$Uint8Array
};
var _map = {
    "Utf8": "utf-8",
    "Utf16": "utf-16"
};
var _revMap = {
    "utf-8": "Utf8",
    "utf-16": "Utf16"
};
function encoderToJs(param) {
    return _map[param];
}
function encoderFromJs(param) {
    return _revMap[param];
}
function Make(Codec) {
    var _$make = function _$make(param) {
        return new TextDecoder(_map[Codec.encoder]);
    };
    return {
        make: _$make,
        decode: function(prim0, prim1) {
            return prim0.decode(prim1);
        }
    };
}
function make(param) {
    return new TextDecoder(_map["Utf16"]);
}
function Utf16_decode(prim0, prim1) {
    return prim0.decode(prim1);
}
var Utf16 = {
    make: make,
    decode: Utf16_decode
};
var $$TextDecoder$1 = {
    encoderToJs: encoderToJs,
    encoderFromJs: encoderFromJs,
    Make: Make,
    Utf16: Utf16
};
function byteSize(unit, s) {
    var bytes = new TextEncoder().encode(s).length;
    if (unit) {
        return Js_math.ceil(bytes / 1000);
    } else {
        return bytes;
    }
}
function containsNewLine(s) {
    return RegExUtils$SmartcutsMacros.newLineRe.test(s);
}
function isComposedOfJustNewLines(s) {
    return /^\n+$/gm.test(s);
}
function myMatch(str, regex) {
    return Caml_option.nullable_to_opt(str.match(regex));
}
function countNewLines(s) {
    var matches = s.match(RegExUtils$SmartcutsMacros.newLineReGlobal);
    if (!(matches == null)) {
        return (matches == null ? undefined : Caml_option.some(matches)).length;
    } else {
        return 0;
    }
}
function countConsecutiveStartingNewLines(s) {
    var matches = s.match(RegExUtils$SmartcutsMacros.startingConsecutiveNewLinesReGlobal);
    if (matches == null) {
        return 0;
    }
    var match = Belt_Array.get(matches == null ? undefined : Caml_option.some(matches), 0);
    if (match === undefined) {
        return 0;
    }
    var firstDefinedMatch = Caml_option.valFromOption(match);
    if (firstDefinedMatch !== undefined) {
        return firstDefinedMatch.length;
    } else {
        return 0;
    }
}
function isToken(s) {
    return RegExUtils$SmartcutsMacros.tokenRe.test(s);
}
var doesSupportNativeReplaceAll = "replaceAll" in String.prototype;
function replaceAll2_nonNative(s, replace, replaceWith) {
    return s.split(replace).join(replaceWith);
}
function replaceAll(replace, replaceWith, s) {
    if (doesSupportNativeReplaceAll) {
        return s.replaceAll(replace, replaceWith);
    } else {
        return replaceAll2_nonNative(s, replace, replaceWith);
    }
}
var nbsp = String.fromCharCode(160);
function reduce(str, init, f) {
    var len = str.length;
    var _indexOpt;
    var _valueOpt;
    var _param;
    while(true){
        var indexOpt = _indexOpt;
        var valueOpt = _valueOpt;
        var index = indexOpt !== undefined ? indexOpt : 0;
        var value = valueOpt !== undefined ? Caml_option.valFromOption(valueOpt) : init;
        if (index >= len) {
            return value;
        }
        var x = str.charAt(index);
        var value$p = Curry._2(f, value, x);
        _param = undefined;
        _valueOpt = Caml_option.some(value$p);
        _indexOpt = index + 1 | 0;
        continue;
    }
    ;
}
function escapeQuotes(param) {
    return replaceAll('"', '\\"', param);
}
var isAnyOf = $$Array.mem;
function replaceNonBreakingSpacesWithSpaces(s) {
    return s.replace(new RegExp(String.fromCharCode(160)), " ");
}
function getNonAlphaNumericSuffix(s) {
    var maybeSuffix = OptionUtils$SmartcutsMacros.map(Belt_Array.reduce(s.split(""), undefined, function(maybeNonAlphaNumericSuffix, character) {
        if (/\w/.test(character)) {
            return maybeNonAlphaNumericSuffix;
        } else if (maybeNonAlphaNumericSuffix !== undefined) {
            return maybeNonAlphaNumericSuffix + character;
        } else {
            return character;
        }
    }), function(suffixWithPossibleTrailingSpace) {
        return suffixWithPossibleTrailingSpace.replace(/\s+$/, "");
    });
    if (maybeSuffix === "") {
        return;
    } else {
        return maybeSuffix;
    }
}
var arg = {
    currency: "USD",
    currencyDisplay: "symbol",
    style: "currency",
    minimumFractionDigits: 2
};
var currencyFormat = function(param) {
    return new Intl.NumberFormat(param, arg);
}(Intl$SmartcutsMacros.Locale.enUS);
var numberFormat2 = new Intl.NumberFormat(Intl$SmartcutsMacros.Locale.enUS, {});
function splitIntoPrefixesInner(text, maybeLimit, param1) {
    var tmp;
    if (maybeLimit !== undefined) {
        var partial_arg = /\s+/;
        tmp = function tmp(param) {
            return param.split(partial_arg, maybeLimit);
        };
    } else {
        var partial_arg$1 = /\s+/;
        tmp = function tmp(param) {
            return param.split(partial_arg$1);
        };
    }
    return Belt_Array.reduce(Belt_Array.keepMap(tmp(text), function(x) {
        return x;
    }), [
        [],
        text
    ], function(param, token) {
        var remainingTextWithoutPrefix = param[1];
        var possiblePrefixes = param[0];
        var lastPrefix = Belt_Array.get(possiblePrefixes, Caml.caml_int_max(possiblePrefixes.length - 1 | 0, 0));
        if (lastPrefix !== undefined) {
            var indexOfToken = remainingTextWithoutPrefix.indexOf(token);
            var textBetweenLastPrefixAndNextToken = remainingTextWithoutPrefix.slice(0, indexOfToken);
            var nextRemainingTextWithoutPrefix = remainingTextWithoutPrefix.slice(indexOfToken + token.length | 0);
            var nextPossiblePrefixes = $$Array.append(possiblePrefixes, [
                lastPrefix + (textBetweenLastPrefixAndNextToken + token)
            ]);
            return [
                nextPossiblePrefixes,
                nextRemainingTextWithoutPrefix
            ];
        }
        var nextRemainingTextWithoutPrefix$1 = remainingTextWithoutPrefix.slice(token.length);
        return [
            [
                token
            ],
            nextRemainingTextWithoutPrefix$1
        ];
    })[0];
}
function splitIntoPrefixes(text) {
    return splitIntoPrefixesInner(text, undefined, undefined);
}
function splitIntoPrefixesAtMost(text, limit) {
    return splitIntoPrefixesInner(text, limit, undefined);
}
function stringifyListAsLengthProp(list) {
    return "{len: " + (String(List.length(list)) + "}");
}
exports.withOrd = withOrd;
exports.isNewLine = isNewLine;
exports.quote = quote;
exports.indent = indent;
exports.repeat = repeat;
exports.reverse = reverse;
exports.join = join;
exports.split = split;
exports.slice = slice;
exports.endsWith = endsWith;
exports.beginsWith = beginsWith;
exports.capitalizeFirstLetter = capitalizeFirstLetter;
exports.removeTrailingSuffix = removeTrailingSuffix;
exports.removeLeadingPrefix = removeLeadingPrefix;
exports.commonPrefix = commonPrefix;
exports.joinArrayWithCommaAnd = joinArrayWithCommaAnd;
exports.pluralize = pluralize;
exports.$$TextEncoder = $$TextEncoder;
exports.$$TextDecoder = $$TextDecoder$1;
exports.byteSize = byteSize;
exports.containsNewLine = containsNewLine;
exports.isComposedOfJustNewLines = isComposedOfJustNewLines;
exports.myMatch = myMatch;
exports.countNewLines = countNewLines;
exports.countConsecutiveStartingNewLines = countConsecutiveStartingNewLines;
exports.isToken = isToken;
exports.doesSupportNativeReplaceAll = doesSupportNativeReplaceAll;
exports.replaceAll2_nonNative = replaceAll2_nonNative;
exports.replaceAll = replaceAll;
exports.nbsp = nbsp;
exports.reduce = reduce;
exports.escapeQuotes = escapeQuotes;
exports.isAnyOf = isAnyOf;
exports.replaceNonBreakingSpacesWithSpaces = replaceNonBreakingSpacesWithSpaces;
exports.getNonAlphaNumericSuffix = getNonAlphaNumericSuffix;
exports.currencyFormat = currencyFormat;
exports.numberFormat2 = numberFormat2;
exports.splitIntoPrefixes = splitIntoPrefixes;
exports.splitIntoPrefixesAtMost = splitIntoPrefixesAtMost;
exports.stringifyListAsLengthProp = stringifyListAsLengthProp; /*  Not a pure module */ 


/***/ })

}]);